import { render, staticRenderFns } from "./EcocupCounter.vue?vue&type=template&id=ecf8f504"
import script from "./EcocupCounter.vue?vue&type=script&lang=js"
export * from "./EcocupCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports